import React, { useContext } from 'react'
import { INewCaptureInfo } from '../../types'
import Buttons from './buttons'
import { CreationCaptureInfoContext } from './manager'

type Props = {
    className?: string
    defaultLabel: string
    uploadProgress?: number
    isUploading?: boolean
    defaultOnSave: (info: INewCaptureInfo) => void
    defaultOnCancel: () => void
}

const CreationCaptureInfoSectionButtons = ({
    className,
    defaultLabel,
    uploadProgress,
    isUploading,
    defaultOnSave,
    defaultOnCancel,
}: Props) => {
    const { isWatermarkOpen, setIsWatermarkOpen, isCustomFontOpen, setIsCustomFontOpen } = useContext(
        CreationCaptureInfoContext
    )

    const onCancel = () => {
        if (isWatermarkOpen) {
            setIsWatermarkOpen(false)
        }
        if (isCustomFontOpen) {
            setIsCustomFontOpen(false)
        }
    }

    const onSave = () => {
        if (isWatermarkOpen) {
            console.log('watermark')
        }
        if (isCustomFontOpen) {
            console.log('font')
        }
        onCancel()
    }

    return (
        <Buttons
            {...{
                className: className,
                saveLabel: isWatermarkOpen || isCustomFontOpen ? 'Save Changes' : defaultLabel,
                isUploading: isUploading,
                uploadProgress: uploadProgress,
                onSave: isWatermarkOpen || isCustomFontOpen ? onSave : defaultOnSave,
                onCancel: isWatermarkOpen || isCustomFontOpen ? onCancel : defaultOnCancel,
            }}
        />
    )
}

export default CreationCaptureInfoSectionButtons
